
import Vue from "vue";
import { getCompanyName } from "~/assets/config/brandNames";

export default Vue.extend({
  name: "BrandIdentity",
  props: {
    showBrand: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    identityText(): string {
      const suffix = this.showBrand
        ? ` ${getCompanyName(process.env.AGENT)}`
        : ":";

      return `KTE — Know Thy Enemy · a Kube Partners platform designed for${suffix}`;
    },
  },
});
